import Select from "./select";
import { TestDistributionRuleAssignedTo } from "models/settings";

interface Props {
  value: TestDistributionRuleAssignedTo;
  label?: string;
  error?: string;
  onChange: (v: TestDistributionRuleAssignedTo) => any;
  hideOther?: boolean;
}

const TestDistributionRuleAssignedToSelect = ({ value, label, error, onChange, hideOther }: Props) => {
  const options = Object.keys(TestDistributionRuleAssignedTo);

  if (hideOther) {
    options.pop();
  }

  return (
    <Select
      error={error}
      label={label}
      className="test-distribution-rule-assigned-to-select"
      value={value}
      options={options}
      onChange={(v) => onChange(TestDistributionRuleAssignedTo[v] || null)}
    />
  );
};

export default TestDistributionRuleAssignedToSelect;
